import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { errMsg, http, money } from "@/lib/api";

export const CheckoutDialog = ({ item, mode, onClose }) => {
  const [f, setF] = useState({ name: "", email: "", organization: "", quantity: 1, display: "name_only" });
  const [busy, setBusy] = useState(false);
  if (!item) return null;
  const isTicket = mode === "ticket";
  const total = item.price * (isTicket ? Number(f.quantity) || 1 : 1);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = isTicket
      ? { tier_id: item.id, quantity: Number(f.quantity), name: f.name, email: f.email, origin_url: window.location.origin }
      : { package_id: item.id, name: f.name, email: f.email, organization: f.organization, display: f.display, origin_url: window.location.origin };
    try {
      const { data } = await http.post(isTicket ? "/checkout/ticket" : "/checkout/sponsorship", body);
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-mas-cream text-ink border-2 border-mas-ink rounded-none max-w-md" data-testid="checkout-dialog">
        <DialogHeader>
          <p className="eyebrow">{isTicket ? "Def Street tickets" : "Sponsorship"}</p>
          <DialogTitle className="font-serif text-3xl">{item.name}</DialogTitle>
          <DialogDescription className="text-mas-mute">{item.description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input required className="field" placeholder="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="checkout-name-input" />
          <input required type="email" className="field" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="checkout-email-input" />
          {isTicket ? (
            <label className="flex items-center justify-between gap-3">
              <span className="text-sm font-medium">Quantity</span>
              <input type="number" min="1" max={Math.min(20, item.remaining ?? 20)} className="field !w-24" value={f.quantity} onChange={(e) => setF({ ...f, quantity: e.target.value })} data-testid="checkout-quantity-input" />
            </label>
          ) : (
            <>
              <input className="field" placeholder="Organization (optional)" value={f.organization} onChange={(e) => setF({ ...f, organization: e.target.value })} data-testid="checkout-organization-input" />
              <select className="field" value={f.display} onChange={(e) => setF({ ...f, display: e.target.value })} data-testid="checkout-display-select">
                <option value="public_amount">Recognize me with name & amount</option>
                <option value="name_only">Recognize me by name only</option>
                <option value="anonymous">Keep me anonymous</option>
              </select>
            </>
          )}
          <div className="flex items-center justify-between border-t border-mas-sand pt-4">
            <span className="font-mono text-xs uppercase tracking-wider">Total</span>
            <span className="font-serif text-2xl font-bold" data-testid="checkout-total">{money(total, true)}</span>
          </div>
          <button disabled={busy} className="btn-terra w-full" data-testid="checkout-submit-button">{busy ? "Opening secure checkout..." : "Continue to secure payment"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
